import React from "react";
import { func, bool } from "prop-types";

import MapButton from "../shared/MapButton";
import FilterIcon from "../shared/Icons/Filter";
import CloseIcon from "../shared/Icons/Close";

import gtm from "@gtm/core";
import { displayMapFilterEvent } from "@gtm/events/testdrive";
import { useTranslation } from "@lib/i18n";
import Icon from "@components/shared/Icons/Icon";

const MapFilterButton = ({ setIsFilterOpen, isFilterOpen }) => {
  const { t } = useTranslation();

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
    if (!isFilterOpen) {
      gtm.fire(displayMapFilterEvent());
    }
  };

  return (
    <MapButton
      aria-label={isFilterOpen ? t("basket.back") : "Filter"}
      onClick={toggleFilter}
    >
      <Icon
        className="size-full text-primaryDark"
        icon={
          isFilterOpen ? (
            <CloseIcon data-id="test-drive-map-filter-close-icon" />
          ) : (
            <FilterIcon data-id="test-drive-map-filter-icon" />
          )
        }
      />
    </MapButton>
  );
};

MapFilterButton.propTypes = {
  isFilterOpen: bool.isRequired,
  setIsFilterOpen: func.isRequired,
};

export default MapFilterButton;
